import React from "react";
import { trackReportStyle } from "../../components/Reports/Timps/style";
import { themeService } from "../../theme/service/activeTheme.service";
import "./style.css";
import { languageService } from "../../Language/language.service";
export const ReportSelectorTable = ({ containerStyle, cols, data }) => {
  let cStyle = containerStyle || {};
  let rows =
    data &&
    data.map((d, index) => {
      return (
        <tr key={d.id + index}>
          {cols.map((col) => {
            let value = "";
            if (col.accessor) value = col.accessor(d);
            else value = d[col.id];
            return <td>{value}</td>;
          })}
        </tr>
      );
    });
  return (
    <div
      className="mainContent table-report switch-side-track report-selection"
      style={{ ...themeService(trackReportStyle.mainStyle), background: "transparent", ...cStyle }}
    >
      <table className="table-selection">
        <thead>
          <tr>
            {cols &&
              cols.map((col) => {
                return (
                  <th data-field={col.id} style={{ width: col.width || "10px" }}>
                    {languageService(col.text)}
                  </th>
                );
              })}
          </tr>
        </thead>
        <tbody style={{ background: "var(--fifth)", fontSize: "12px" }}>{rows}</tbody>
      </table>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/CommonUI/ReportSelectorTable/ReportSelectorTable.js